import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-later',
  templateUrl: './later.component.html',
  styleUrls: ['./later.component.css']
})
export class LaterComponent implements OnInit {

  constructor() { } 
  stuff : Date = new Date()
  ngOnInit(): void {
  }

}
